import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useAuth } from "@/context/AuthContext";

const STEPS = [
  ["/app", "Bem-vindo ao PROSPERA+", "Este é um tour rápido pelas abas principais. A Visão geral mostra seu score de saúde financeira, fluxo de caixa e prioridades."],
  ["/app/lancamentos", "Lançamentos", "Registre receitas e despesas com forma de pagamento (PIX, débito, crédito...). Você também pode lançar pela foto do recibo."],
  ["/app/dividas", "Dívidas", "Organize as dívidas, compare o valor de quitação e escolha a melhor estratégia para pagar menos juros."],
  ["/app/patrimonio", "Patrimônio", "Cadastre bens e investimentos para acompanhar o patrimônio líquido e a diversificação."],
  ["/app/planejamento", "Planejamento", "Veja projeções de 12 meses, 5 e 30 anos calculadas a partir do seu diagnóstico."],
  ["/app/metas", "Metas & Tarefas", "Crie metas com prazo e siga o cronograma mensal de tarefas."],
  ["/app/empresa", "Diagnóstico Empresarial", "Cadastre suas empresas, lance receitas e despesas, veja os nove indicadores, simule cenários e peça um diagnóstico com IA (planos Empresarial e Premium)."],
  ["/app/mentor", "Mentor IA", "Tire dúvidas com o mentor financeiro, que considera os números do seu espaço."],
  ["/app/guia", "Guia de uso", "Sempre que precisar, use o botão \"Como usar esta página\" em cada aba ou abra este guia completo."],
];

export const tourKey = (uid) => `prospera_tour_done_${uid}`;

export const Tour = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [step, setStep] = useState(-1);
  useEffect(() => {
    if (!user) { return; }
    const start = () => { setStep(0); navigate(STEPS[0][0]); };
    if (!localStorage.getItem(tourKey(user.id))) { start(); }
    window.addEventListener("prospera:tour", start);
    return () => { window.removeEventListener("prospera:tour", start); };
  }, [user, navigate]);
  const close = () => { localStorage.setItem(tourKey(user.id), "1"); setStep(-1); };
  const go = (i) => { setStep(i); navigate(STEPS[i][0]); };
  if (step < 0) return null;
  const [, title, text] = STEPS[step];
  const last = step === STEPS.length - 1;
  return (
    <Dialog open onOpenChange={(o) => { if (!o) { close(); } }}>
      <DialogContent className="border-[#D4AF37]/40 bg-[#0F2242] text-white sm:max-w-md" data-testid="tour-dialog">
        <DialogHeader>
          <div className="text-[11px] uppercase tracking-[0.25em] text-[#D4AF37]" data-testid="tour-progress">Passo {step + 1} de {STEPS.length}</div>
          <DialogTitle data-testid="tour-title">{title}</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-slate-300">{text}</p>
        <div className="mt-2 flex gap-1">{STEPS.map((_, i) => <span key={i} className={`h-1 flex-1 rounded ${i <= step ? "bg-[#D4AF37]" : "bg-[#1E3A6E]"}`} />)}</div>
        <div className="mt-4 flex items-center justify-between">
          <Button variant="ghost" className="text-slate-400" onClick={close} data-testid="tour-skip-btn">Pular tour</Button>
          <div className="flex gap-2">
            {step > 0 && <Button variant="outline" className="border-[#1E3A6E] bg-transparent" onClick={() => go(step - 1)} data-testid="tour-prev-btn">Anterior</Button>}
            <Button onClick={() => (last ? close() : go(step + 1))} data-testid="tour-next-btn">{last ? "Concluir" : "Próximo"}</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
